import { render, staticRenderFns } from "./WizzardLargeCard.vue?vue&type=template&id=ef3db36e&scoped=true&"
import script from "./WizzardLargeCard.vue?vue&type=script&lang=js&"
export * from "./WizzardLargeCard.vue?vue&type=script&lang=js&"
import style0 from "./WizzardLargeCard.vue?vue&type=style&index=0&id=ef3db36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3db36e",
  null
  
)

export default component.exports